<template>
	<div class="container-fluid">
		<router-view :key="UARM_FORCE_RELOAD_ROUTER_KEY" />
		<!-- дефолтный холдер который будет задействован при вызове this.$notify('Мой текст') -->
		<notifications :speed="100" />
	</div>
</template>

<script>
import Vue from 'vue';

/*
НЕ ТРОГАТЬ IMPORT
ПРИ СБОРКЕ npm run build /dist/index.html НЕ СОЗДАЕТСЯ
*/
import index_html from '@uarm/public/index.html';
import p_list from './p_list.vue';
import p_card from './p_card.vue';

import VueRouter from 'vue-router';
import Notifications from 'vue-notification';
import VueLocalStorage from '@uarmSrc/plugins/localStorage';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Notifications);
Vue.use(VueLocalStorage);

// АХТУНГ! чтобы работал предпросмотр, маршруты PageList и PageCard
// должны быть унифицированы в следующих файлах:
// - uarm-front\src\App.vue
// - wizard\src\App.vue
var routes = [
	{
		name: 'ArmView_List',
		path: '/list/:vpId/:armId/:specMode?', // specMode - это способ передавать через урл всякие кастомные вещи без риска поломать квери. Например, если передать sp, то АРМ будет ходить по урлу /api/sp/arm
		component: p_list,
	},
	{
		name: 'ArmView_Card',
		path: '/card/:vpId/:armId/:recordId/:specMode?', // specMode - это способ передавать через урл всякие кастомные вещи без риска поломать квери. Например, если передать sp, то АРМ будет ходить по урлу /api/sp/arm
		component: p_card,
	},
	{
		path: '/', // root, без параметров
		component: {
			render: function (createElement) {
				return createElement('h2', 'Пожалуйста, выберите АРМ');
			},
		},
	},
	{
		path: '*', // 404
		component: {
			render: function (createElement) {
				return createElement('h1', '404');
			},
		},
	},
];

// ВНИМАНИЕ! СТРОКА КОДА НИЖЕ ОДИНАКОВАЯ В:
// - uarm (entry-point.js)
// и
// - wizard (main.js)
// Причина такая:
// global-component-page-list пришлось зарегать глобально (префикс g- означает именно это) потому что
// иначе (при импорте где нужно) случалась circular dependency
// p_list -> контрол popup-picker (всплывающий арм) -> p_list
// в результате которой импорт становился undefined, а компонент соответственно не зареганным
// вообще можно было через async import решить например https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
Vue.component('global-component-page-list', p_list);
Vue.component('global-component-page-card', p_card);

require('@uarm/public/fonts/glyphicons-halflings-regular.eot');
require('@uarm/public/fonts/glyphicons-halflings-regular.ttf');
require('@uarm/public/fonts/glyphicons-halflings-regular.svg');
require('@uarm/public/fonts/glyphicons-halflings-regular.woff');
require('@uarm/public/fonts/glyphicons-halflings-regular.woff2');

const AppRoot = {
	name: 'AppRoot',
	data() {
		return {
			UARM_FORCE_RELOAD_ROUTER_KEY: 1,
		};
	},
	router: new VueRouter({
		routes,
	}),
	// ВНИМАНИЕ! created/destroyed/UARM_FORCE_RELOAD_ROUTER_KEY одинаковые в uarm (App.vue) и wizard (App.vue)
	created() {
		window.UARM_FORCE_RELOAD_ROUTER = () => {
			// это специальная функция чтобы принудительно заново инициализировать компоненты внутри роутера без перезагрузки страницы в браузере
			// https://michaelnthiessen.com/force-re-render
			this.$data.UARM_FORCE_RELOAD_ROUTER_KEY++;
		};
	},
	destroyed() {
		delete window.UARM_FORCE_RELOAD_ROUTER;
	},
};

window.VUEI_AppRoot = AppRoot;

export default AppRoot;
</script>
